import { jsx as C } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ C("svg", { fill: "none", height: "1em", viewBox: "0 0 24 24", width: "1em", ...e, children: /* @__PURE__ */ C(
    "path",
    {
      d: "M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V5C2 4.45 2.19583 3.97917 2.5875 3.5875C2.97917 3.19583 3.45 3 4 3H20C20.55 3 21.0208 3.19583 21.4125 3.5875C21.8042 3.97917 22 4.45 22 5V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H16V20C16 20.2833 15.9042 20.5208 15.7125 20.7125C15.5208 20.9042 15.2833 21 15 21H9C8.71667 21 8.47917 20.9042 8.2875 20.7125C8.09583 20.5208 8 20.2833 8 20V19H4ZM4 17H20V5H4V17Z",
      fill: "currentColor"
    }
  ) });
}
export {
  t as default
};
